// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__KgV_L","tabLabel":"Tabs_tabLabel__1Ue6f","tab":"Tabs_tab__bPPJg"};